export default {
  list: '/income/client/card/list'
}
